var suncountry = {
    drawerActionButton: null,
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    en: {
        termsAndConditionsLink: 'https://www.synchronybankterms.com/syfterms/html/suncountry_reward_terms.html'
    },
    es: {
        termsAndConditionsLink: 'https://www.synchronybankterms.com/syfterms/html/suncountry_reward_terms.html'
    },
    howToEarnPointsHeader: 'fullDetailsPage.howToEarnPointsHeader',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationViewPrintKey: null,
    DUAL_CARD: {
        actionButton: {
            text: 'shopMore.suncountryButtonText',
            link: 'https://www.suncountry.com/(nav:login)'
        },
        banner: 'suncountry-banner-DC-md.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {
                inBrand: { icon: ['far', 'plane'] },
                gasGrocery: {
                    icon: ['far', 'basket-shopping']
                },
                world: { icon: ['far', 'earth-america'] },
                bonus: { icon: ['far', 'money-bills'] },
                adjustment: {
                    icon: ['far', 'calculator']
                }
            },
            titleKey: 'sunCountryEarnings.yourSunCountryEarnings'
        },
        faqs: 'https://www.suncountry.com/help-center/sun-country-rewards#label-question-info',
        perks: [
            {
                icon: ['fal', 'suitcase'],
                titleTranslationKey: 'earnOffOnSuitcaseTitle',
                descriptionTranslationKey: 'earnOffOnSuitcaseDescription'
            },
            {
                icon: ['fal', 'seat-airline'],
                titleTranslationKey: 'flyAndEarnTitle',
                descriptionTranslationKey: 'flyAndEarnDescription'
            },
            {
                icon: ['fal', 'party-horn'],
                titleTranslationKey: 'earnBonusPointsTitle',
                descriptionTranslationKey: 'earnBonusPointsDescription'
            }
        ],
        rewardsBalance: true,
        translationKey: 'faqs.suncountryDescription',
        snapshotTranslationKey: 'faqs.suncountrySnapshotDescription',
        valuePropImg: '',
        en: {
            propositions: [
                {
                    description: 'Earn 3 points per $1 spend on Sun Country purchases.*',
                    heading: 'earn',
                    points: '3 points'
                },
                {
                    description: 'Earn 2 points per $1 spend on gas station and grocery store purchases.*',
                    heading: 'earn',
                    points: '2 points'
                },
                {
                    description: 'Earn 1 point per $1 spent on all other purchases.*',
                    heading: 'earn',
                    points: '1 point'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga 3 puntos por cada $1 que gaste en compras de Sun Country.*',
                    heading: 'obtenga',
                    points: '3 puntos'
                },
                {
                    description: 'Obtenga 2 puntos por cada $1 que gaste en compras en gasolineras y supermercados.*',
                    heading: 'obtenga',
                    points: '2 puntos'
                },
                {
                    description: 'Obtenga 1 punto por cada $1 gastado en todas las demás compras.*',
                    heading: 'obtenga',
                    points: '1 punto'
                }
            ]
        }
    }
};
export default suncountry;
